import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useQuery } from '../hooks/useQuery';
import CircularProgress from '@mui/material/CircularProgress';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import InputMask from 'react-input-mask';
import Moment from 'moment';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';
import { statuses } from '../utils';
import 'moment/locale/pt-br';
import ReactJson from 'react-json-view';
import copy from 'copy-to-clipboard';

export const LogsPage = (props) => {
  const { listarLogs } = useQuery();
  const [logs, setLogs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [dataInicio, setDataInicio] = React.useState(Moment().startOf('year'));
  const [dataFim, setDataFim] = React.useState(Moment().endOf('year'));
  const [status, setStatus] = React.useState([]);
  const [categorias, setCategorias] = React.useState([]);
  const [services, setServices] = React.useState([]);
  const [numNota, setNumNota] = React.useState('');
  const [cnpj, setCnpj] = React.useState('');
  const [selected, setSelected] = React.useState();
  const navigate = useNavigate();
  const datePickerRef = React.useRef();
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const [lastPage, setLastPage] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  let { contratoId } = useParams();
  const theme = useTheme();
  const [runRequest, setRunRequest] = React.useState(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const handleChange = (event, value) => {
    setPage(value);
    listar(value);
  };

  const getFilters = () => {
    var filters = {};

    if (status.length > 0) {
      filters.status = status;
    }
    if (services.length > 0) {
      filters.services = services;
    }
    if (categorias.length > 0) {
      filters.categorias = categorias;
    }
    if (dataInicio !== '') {
      filters.data_inicio = dataInicio.format('YYYY-MM-DD');
    }
    if (dataFim !== '') {
      filters.data_fim = dataFim.format('YYYY-MM-DD');
    }
    if (numNota !== '') {
      filters.num_nota = numNota;
    }

    if (cnpj !== '') {
      filters.cnpj = cnpj.replace(/[^a-zA-Z0-9]/g, '');
    }

    return filters;
  };
  const listar = async (pagina = 1) => {
    setLoading(true);
    let filters = getFilters();
    filters.paginate = true;
    filters.page = pagina;
    const result = await listarLogs(filters);

    if (result && result.data) {
      setLogs(
        result.data.data.data.map((item) => ({ ...item, isLoading: false })),
      );
    }

    setPage(result.data.data.current_page);
    setLastPage(result.data.data.last_page);
    setTotal(result.data.data.total);
    setLoading(false);
  };

  const handleOnChangeFiltro = (event, value) => {
    const finalValue = event.target.value;
    if (event.target.checked) {
      status.push(finalValue);
      setStatus([...status]);
    } else {
      const idx = status.indexOf(finalValue);
      status.splice(idx, 1);
      setStatus([...status]);
    }
  };

  const handleOnChangeFiltroCategoria = (event, value) => {
    const finalValue = event.target.value;
    if (event.target.checked) {
      categorias.push(finalValue);
      setCategorias([...categorias]);
    } else {
      const idx = categorias.indexOf(finalValue);
      categorias.splice(idx, 1);
      setCategorias([...categorias]);
    }
  };

  const handleOnChangeFiltroService = (event, value) => {
    const finalValue = event.target.value;
    if (event.target.checked) {
      services.push(finalValue);
      setServices([...services]);
    } else {
      const idx = services.indexOf(finalValue);
      services.splice(idx, 1);
      setServices([...services]);
    }
  };

  const handleChangeInicio = (newValue) => {
    setDataInicio(newValue);
  };

  const handleChangeFim = (newValue) => {
    setDataFim(newValue);
  };

  const handleChangeNumNota = (event) => {
    setNumNota(event.target.value);
  };

  const handleChangeCnpj = (event) => {
    setCnpj(event.target.value);
  };

  const openModal = (value) => {
    setSelected(value);
    handleOpen();
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function isJsonString(str) {
    if (typeof text !== 'string') {
      return false;
    }
    try {
      var json = JSON.parse(str);
      return typeof json === 'object';
    } catch (error) {
      return false;
    }
  }

  React.useEffect(() => {
    listar();
  }, [runRequest]);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>Log de Erros</span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
        >
          <Box sx={{ ...style, width: '90%' }}>
            <h2 id="parent-modal-title">Request</h2>
            <ReactJson
              src={
                selected && selected.request && isJsonString(selected.request)
                  ? JSON.parse(selected.request)
                  : [selected && selected.request ? selected.request : '']
              }
              style={{ height: 200, overflowY: 'scroll' }}
              enableClipboard={(copyText) => copy(JSON.stringify(copyText))}
            />
            <h2 id="parent-modal-title">Response</h2>

            <span></span>
            <ReactJson
              src={
                selected && selected.response && isJsonString(selected.response)
                  ? JSON.parse(selected.response)
                  : [selected && selected.response ? selected.response : '']
              }
              style={{ height: 200, overflowY: 'scroll' }}
              enableClipboard={(copyText) => copy(JSON.stringify(copyText))}
            />
            <h2 id="parent-modal-title">Capa</h2>
            <ReactJson
              src={
                selected && selected.capa && isJsonString(selected.capa)
                  ? JSON.parse(selected.capa)
                  : [selected && selected.capa ? selected.capa : '']
              }
              style={{ height: 200, overflowY: 'scroll' }}
              enableClipboard={(copyText) => copy(JSON.stringify(copyText))}
            />
          </Box>
        </Modal>
      </Grid>
      <Grid
        container
        paddingX={2}
        direction={{ xs: 'column-reverse', md: 'row', lg: 'row' }}
      >
        <Grid item xs={12} md="9" width="100%">
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ marginTop: 60 }} />
            </Box>
          ) : (
            <div style={{ width: '100%', overflowY: 'scroll' }}>
              <table className="app_table">
                <thead
                  style={{
                    color: theme.palette.primary.main,
                    borderTop: `8px solid ${theme.palette.primary.light}`,
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: '10%',
                      }}
                    >
                      Serviço
                    </th>
                    <th
                      style={{
                        width: '20%',
                      }}
                    >
                      Nº da Nota
                    </th>
                    <th
                      style={{
                        width: '10%',
                      }}
                    >
                      Nº Processo
                    </th>
                    <th
                      style={{
                        width: '15%',
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        width: '15%',
                      }}
                    >
                      CNPJ
                    </th>
                    <th
                      style={{
                        width: '10%',
                      }}
                    >
                      Data/Hora
                    </th>
                    <th
                      style={{
                        width: '20%',
                      }}
                    >
                      Detalhes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {logs &&
                    logs.length > 0 &&
                    logs.map((log, index) => (
                      <tr>
                        <td style={{ textAlign: 'left' }}>{log.servico}</td>
                        <td style={{ textAlign: 'left' }}>{log.numero_nf}</td>
                        <td
                          style={{
                            textAlign: 'left',
                            maxWidth: '10px',
                            overflow: 'hidden',
                          }}
                        >
                          {log.numero_processo_fluig}
                        </td>
                        <td style={{ textAlign: 'left' }}>{log.tipo}</td>
                        <td style={{ textAlign: 'left' }}>{log.cnpj}</td>
                        <td style={{ textAlign: 'left' }}>
                          {Moment(log.created_at).format('DD/MM/YYYY hh:mm')}
                        </td>
                        <td style={{ textAlign: 'left' }}>
                          <Button
                            variant="contained"
                            onClick={() => openModal(log)}
                            style={{ width: '100%', marginTop: 10 }}
                          >
                            Request/Response
                          </Button>
                        </td>
                      </tr>
                    ))}
                  {!loading && logs && logs.length == 0 ? (
                    <tr>
                      <td colSpan={6} align="center">
                        Nenhum log encontrado.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Pagination
                  count={lastPage}
                  page={page}
                  color={'primary'}
                  onChange={handleChange}
                />
              </Box>
            </div>
          )}
        </Grid>
        <Grid
          item
          sm={3}
          sx={{
            paddingLeft: { xs: 2 },
            paddingRight: { xs: 2 },
          }}
        >
          <Card
            variant="outlined"
            style={{
              borderTop: `8px solid ${theme.palette.primary.light}`,
            }}
          >
            <CardContent>
              <p
                style={{
                  color: '#0e72b8',
                  marginTop: 0,
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <FilterAltIcon color="primary" />
                Filtro
              </p>
              <p style={{ color: '#0e72b8', marginTop: 0, fontWeight: 'bold' }}>
                Status
              </p>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Erro"
                      checked={status.includes('Erro')}
                      onChange={(e) => handleOnChangeFiltro(e, 'Erro')}
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'Erro'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Sucesso"
                      checked={status.includes('Sucesso')}
                      onChange={(e) => handleOnChangeFiltro(e, 'Sucesso')}
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'Sucesso'}
                />
              </FormGroup>
              <p style={{ color: '#0e72b8', marginTop: 0, fontWeight: 'bold' }}>
                Tipo integração
              </p>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Fluig"
                      checked={services.includes('Fluig')}
                      onChange={(e) => handleOnChangeFiltroService(e, 'Fluig')}
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'Fluig'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="DataSul"
                      checked={services.includes('DataSul')}
                      onChange={(e) =>
                        handleOnChangeFiltroService(e, 'DataSul')
                      }
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'DataSul'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Transfeera"
                      checked={services.includes('Transfeera')}
                      onChange={(e) =>
                        handleOnChangeFiltroService(e, 'Transfeera')
                      }
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'Transfeera'}
                />
              </FormGroup>
              <p style={{ color: '#0e72b8', marginTop: 0, fontWeight: 'bold' }}>
                Categoria
              </p>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="NotaFiscal"
                      checked={categorias.includes('NotaFiscal')}
                      onChange={(e) =>
                        handleOnChangeFiltroCategoria(e, 'NotaFiscal')
                      }
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'NotaFiscal'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="PagamentoDireto"
                      checked={categorias.includes('PagamentoDireto')}
                      onChange={(e) =>
                        handleOnChangeFiltroCategoria(e, 'PagamentoDireto')
                      }
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'PagamentoDireto'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="CadastroFornecedor"
                      checked={categorias.includes('CadastroFornecedor')}
                      onChange={(e) =>
                        handleOnChangeFiltroCategoria(e, 'CadastroFornecedor')
                      }
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'Cadastro Fornecedor'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="IA"
                      checked={categorias.includes('IA')}
                      onChange={(e) => handleOnChangeFiltroCategoria(e, 'IA')}
                      style={{ padding: '4px' }}
                    />
                  }
                  label={'IA'}
                />
              </FormGroup>
              <p
                style={{
                  color: '#0e72b8',
                  fontWeight: 'bold',
                  marginBottom: 0,
                }}
              >
                Nº da Nota
              </p>
              <TextField
                style={{ width: '100%' }}
                id="outlined-basic"
                label="Número"
                type="number"
                maxLength={16}
                value={numNota}
                onChange={handleChangeNumNota}
                variant="outlined"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .substring(0, 16)
                    .replace(/[^0-9.]/g, '');
                }}
                inputProps={{
                  min: 0,
                  maxLength: 16,
                }}
              />
              <p
                style={{
                  color: '#0e72b8',
                  fontWeight: 'bold',
                  marginBottom: 0,
                }}
              >
                CNPJ
              </p>

              <InputMask
                mask="**.***.***/****-**"
                maskChar={''}
                onChange={handleChangeCnpj}
                value={cnpj}
              >
                {(inputProps) => (
                  <TextField
                    margin="normal"
                    fullWidth
                    {...inputProps}
                    id="cnpj"
                    label="CNPJ"
                    // autoFocus
                  />
                )}
              </InputMask>
              <Button
                variant="contained"
                onClick={() => listar(contratoId)}
                style={{ width: '100%', marginTop: 10 }}
              >
                Buscar
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setStatus([]);
                  setServices([]);
                  setCategorias([]);
                  setNumNota('');
                  setCnpj('');
                  setRunRequest(!runRequest);
                }}
                style={{ width: '100%', marginTop: 20 }}
              >
                Limpar
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
